import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as mediaActions from '../store/media/actions';
import * as listsActions from '../store/lists/actions';
import * as reducers from '../store/reducers';
import * as settings from 'Settings';

import BookReaderV2 from 'Components/BookReaderV2';
import ContentCollections from 'Containers/ContentCollections';
import ContentHeader from 'Components/ContentHeader';
import ContentTags from 'Components/ContentTags';
import BookInfoBox from 'Components/BookInfoBox';
import RampUnit from '../utils/Playwire/RampUnit';
import BookPageHero from 'Components/BookPageHero';
import ErrorPage from 'Screens/ErrorPage';
import Loading from 'Components/Loading';
import DocumentHeadFields from 'Components/DocumentHeadFields';
import BookAlternateLanguageBox from 'Components/BookAlternateLanguageBox';
import AdditionalMaterials from 'Components/AdditionalMaterials';
import { US_ONLY_BOOKS } from 'Constants/USOnlyBooks';

import { withLocationWrapper } from '../utils/HOC_LocationWrapper';


class BookPage extends Component {
  constructor(props) {
    super(props);

    this.refreshAds = this.refreshAds.bind(this);
    this.enableAdRefresh = this.enableAdRefresh.bind(this);
    this.state = {
      pageLoading: true,
      allowAdRefresh: true,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  refreshAds() {
    // We want to refresh ads no more than every 10 seconds.
    if (this.state.allowAdRefresh) {
      if (
        typeof window.ramp !== 'undefined' &&
        typeof window.ramp.triggerRefresh === 'function'
      )
        window.ramp.triggerRefresh();
      this.setState({ allowAdRefresh: false });
      this.pauseRefreshTimeout = window.setTimeout(this.enableAdRefresh, 10000);
      console.info('Ad refreshes are paused for 10 seconds');
    }
  }

  enableAdRefresh() {
    this.setState({ allowAdRefresh: true });
  }

  componentDidUpdate(prevProps) {
    if (this.props.slug !== prevProps.slug) {
      this.fetchData();
      this.setState({ pageLoading: true });
    }
    if (this.props.countryCode !== prevProps.countryCode) {
      this.fetchData();
      this.setState({ pageLoading: true });
    }
    if (this.props.book && !prevProps.book) {
      this.setState({ pageLoading: false });
    }
    if (!this.props.isFetching && this.state.pageLoading) {
      this.setState({ pageLoading: false });
    }
  }

  fetchData() {
    const { slug, fetchMedia, fetchMediaLists, countryCode } = this.props;
    if (US_ONLY_BOOKS.includes(slug) && countryCode !== 'US') {
      this.setState({ pageLoading: false });
      return;
    }
    fetchMedia(slug);
    const qs = { slug };
    const pathname = `/books/${slug}`;
    fetchMediaLists('bookPermalink', pathname, qs);
  }

  render() {
    const { book, lists, isFetching, errors, slug, countryCode } = this.props;
    const { pageLoading } = this.state;

    const isNotAvailableInCountry =
      US_ONLY_BOOKS.includes(slug) && countryCode !== 'US';

    if (isNotAvailableInCountry || ((errors.media || errors.lists) && !book)) {
      return (
        <ErrorPage
          errorCode="404"
          errorType="pageNotFound"
          errorMessage={errors.media && errors.media.message}
        />
      );
    }

    if (pageLoading) {
      return <Loading />;
    }

    const { supplementalMaterials, alternateLanguageVersions, seriesHeroId } =
      book || {};

    return (
      <main>
        {!isFetching && book && <DocumentHeadFields mediaItem={book} />}
        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>

        <div className="Page__ContentWrapper">
          <div className="Page__container Page__container--split-layout Page__container--main">
            <section className="ContentBlock ContentBlock--content-canvas">
              <div className="ContentBlock__content">
                <ContentHeader {...book} />
                {book && (
                  <BookReaderV2
                    {...book}
                    refreshAds={() => this.refreshAds()}
                  />
                )}
                <div className="Page__item-details">
                  <BookInfoBox {...book} />
                  <div className="ContentTags ContentTags--half-size">
                    <ContentTags {...book} />
                    {alternateLanguageVersions &&
                      alternateLanguageVersions.length > 0 && (
                        <BookAlternateLanguageBox {...book} />
                      )}
                  </div>
                </div>
                {seriesHeroId && <BookPageHero adCampaignKey={seriesHeroId} />}
                {supplementalMaterials && supplementalMaterials.length > 0 && (
                  <AdditionalMaterials
                    items={supplementalMaterials.map(
                      ({
                        title,
                        description,
                        attachments: [{ url, thumbnails }],
                      }) => ({
                        title,
                        description,
                        url,
                        imageUrl: thumbnails.large.url,
                      })
                    )}
                  />
                )}

                <aside className="ContentBlock__aside">
                  <RampUnit type="med_rect_atf" id="siderec" />
                  <RampUnit type="med_rect_btf" id="sideflex" />
                </aside>

                {!isFetching && <ContentCollections lists={lists} />}
              </div>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  const slug = props.params.bookID;
  const pathname = `/books/${slug}`;
  return {
    slug,
    isFetching: reducers.getIsPageFetching(state),
    book: reducers.getMediaItem(state, slug),
    lists: reducers.getMediaLists(state, 'bookPermalink', pathname),
    errors: reducers.getErrors(state),
  };
};

const allActions = {
  ...mediaActions,
  ...listsActions,
};

const BookPageComponent = connect(mapStateToProps, allActions)(BookPage);

export default withLocationWrapper(BookPageComponent);
